import './thefifth3fb/style';
import FormStructure from './thefifth3fb/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/kevin/projects/inquiry-renderer/client_forms/includes.js